<template>
  <div class="layui-collapse advance-collapse">
    <div class="layui-colla-item">
      <!-- <div class="search-title">
        <span>
          所有条件
          <i class="layui-icon layui-icon-triangle-r"></i>
        </span>
        <ul id="searchResult">
          <li v-for="(e, ind) in conditionList()" :key="e.FIELD + ind" v-show="e.VALUE">
            <b>{{e.NAME + ' ' +  e.VALUE}}</b>
            <i class="layui-icon layui-icon-close" @click="queryObject[e.FIELD] = null"></i>
          </li>
        </ul>
        <a class="layui-icon" :class="{'layui-icon-up' : showAdvancedContent,'layui-icon-down': !showAdvancedContent}" id="btn_fold" @click="showAdvancedContent = !showAdvancedContent">{{showAdvancedContent ? '收起' : '展开'}}</a>
      </div> -->
      <div class="layui-colla-content layui-show"  v-show="showAdvancedContent">
        <div style="width:100%;float:left;"  v-show="showAdvancedContent">
          <div id="fundtype" class="search-condition layui-form">
            <template v-for="(e, ind) in advanced" >
                <span :key="e.TYPE + ind" class="avance-span">
                  <div class="layui-inline advance_label"><label class="layui-search-label">{{e.NAME}}</label></div>
                  <div class="layui-inline avance_search">
                    <input
                      type="text"
                      v-if="e.TYPE === 'input'"
                      v-model="queryObject[e.FIELD]"
                      autocomplete="off"
                      class="layui-input"
                      :placeholder="e.PLACEHOLDER"/>

                    <layui-date
                      v-if="e.TYPE === 'date'"
                      placeholder="请输入时间"
                      v-model="queryObject[e.FIELD]"
                    />

                    <layui-daterange
                      v-if="e.TYPE === 'daterange'"
                      placeholder="请输入时间"
                      v-model="queryObject[e.FIELD]"
                    />

                    <layui-datetime
                      v-if="e.TYPE === 'datetime'"
                      placeholder="请输入时间"
                      v-model="queryObject[e.FIELD]"
                    />

                    <layui-datetimerange
                      v-if="e.TYPE === 'datetimerange'"
                      placeholder="请输入时间"
                      v-model="queryObject[e.FIELD]"
                      />

                    <layui-select
                      v-if="e.TYPE === 'select'"
                      :ref="e.ref"
                      v-model="queryObject[e.FIELD]"
                      :table-name="e.tableName"
                      :text-field="e.textField"
                      :value-field="e.valueField"
                      :queryCondition="e.queryCondition"
                      :enableSearch="e.enableSearch"
                      :sort="e.sort"
                      :showNullOption="true"
                      @selectChange="_selectChange($event, e.name)"
                    />

                    <layui-select
                      v-if="e.TYPE === 'select-solt'"
                      v-model="queryObject[e.FIELD]"
                      :init-value = e.initValue
                      :showNullOption="true">
                      <option v-for="j in e.options" :key="j.value" :value="j.value">{{ j.text }}</option>
                    </layui-select>

                    <layui-multiselect
                      v-if="e.TYPE === 'layui-multiselect'"
                      :table-name="e.tableName"
                      :initData='e.initData'
                      :textField="e.textField"
                      :valueField="e.valueField"
                      :idField="e.idField"
                      :parentField="e.parentField"
                      v-model="queryObject[e.FIELD]"
                      :show-null-option="true"
                      :queryCondition="e.queryCondition"
                      :enable-search="false"
                      >
                    </layui-multiselect>

                    <layui-radio
                      v-if="e.TYPE === 'radio'"
                      v-model="queryObject[e.FIELD]">
                        <input
                          type="radio"
                          v-for="j in e.options"
                          :key="j.value"
                          :value="j.value"
                          :title="j.title" />
                    </layui-radio>

                    <layui-check
                      v-if="e.TYPE === 'check'"
                      v-model="queryObject[e.FIELD]"
                      :initData="e.options">
                    </layui-check>
                  </div>
                </span>
            </template>
            </div>
            <div class="clearfloat"></div>
          </div>
          <div style="width:100%;padding-top:10px;" v-show="showAdvancedContent">
            <div style="width:220px;">
              <button id="savecondition" style="background-color: #00A0E9;width:100px;margin-top: 10px;" class="layui-btn" @click="advancedQuery()">确定</button>
              <button id="searchOk" style="border:1px solid #D9D9D9;background-color:#FFF;width:100px;margin-top: 10px;color: #00A0E9" class="layui-btn layui-btn-warm" @click="clear()">清空条件</button>
            </div>
          </div>
        </div>
        <div class="clearfloat"></div>
      </div>
    </div>
</template>
<script>
/**
 * 高级搜索组件
 */
export default {
  name: "AdvancedQuery",
  props: {
    // 引用table对象
    tableObj: {
      type: Object,
      default: () => {
        return {
          queryObject: {}
        }
      }
    },
    //高级搜索配置
    advanced: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      id: null,
      scope: this,
      showAdvancedContent: true,
      queryObject: {}
    };
  },
  mounted() {
    var element = (this.el = $(this.$el));
    var id = (this.id = this.uuid());
    element.attr("id", id);
    //  监控不同屏幕
    this.changeSize()
  },
  methods: {
    changeSize(){
      //  监控不同屏幕   小屏展示 高级搜索   大屏直接展示
      let dom = $('.search-condition').children('.avance-span')
      if( $(window).width() <= 1366 ) {
        dom.width(33 + '%')
        dom.css('margin-right', '0')
        if($('.card-row').find('.advance-wrapper').length){
          dom.width(45 + '%')
        }
      }
    },
      conditionList(){
          var result = [];
          for(var p in this.queryObject) {
              var item = null;
              for(var i = 0 ; i < this.advanced.length; i++) {
                  var temp = this.advanced[i];
                  if(temp.FIELD == p){
                      item = temp;
                      break;
                  }
              }
              if(item) {
                result.push({NAME: item.NAME, FIELD: item.FIELD, VALUE: this.queryObject[p]});
              }
          }
          return result;
      },
      advancedQuery(){
          for(var p in this.queryObject) {
            this.tableObj.queryObject[p] = this.queryObject[p];
          }
          this.tableObj.search();
          this.$emit('advancedQuery')
      },
      //清空查询条件null
      clear(){
          for(var p in this.queryObject) {
            this.queryObject[p] = null;
            this.tableObj.queryObject[p] = null;
          }
          this.tableObj.search();
      },
      _selectChange (data, field) {
        this.$emit('selectChange', data, this.$refs, field)
      }
  }
};
</script>
<style scoped>
.advance-collapse{
  width:100%;
  color: rgb(0, 0, 255);
  background: #FCFCFC;
  z-index: 2001;
  position: absolute;
  border-bottom:1px solid #ccc;
  margin-top: -10px;
}
.search-condition {
  display: flex;
  flex-wrap: wrap;
  justify-content:flex-start;
}

.search-condition span{
  display: flex;
  align-items: center;
  margin-right:12px;
  margin-bottom:5px;
  width:calc((100% - 36px) / 4);
}
/* 看板高级搜索样式设置开始 */
.card-row .advance-wrapper .avance-span{
  width: 42%;
}
.card-row .advance-wrapper{
  width: calc(100% - 22px)!important;
  border:1px solid #ccc!important;
}
/* 看板高级搜索样式设置结束 */
.resize-span{
  width:calc((100% - 24px) / 3);
}
.resize-span:nth-of-type(3n){
  margin-right: 0!important
}
.search-condition span:nth-of-type(4n){
  margin-right: 0;
}

.layui-search-label {
    padding: 9px 5px;
    /* width:95%; */
    width: 100%;
    box-sizing: border-box;
    text-align: right;
}
.advance_label{
  /* width: 32%; */
  width: 9em;
  flex: none;
}
.avance_search{
  /* width:65% */
  flex: 1;
}
.avance_search >>> xm-select[size='small'] {
  min-height: 30px;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.avance_search>span{
  width: 100%;
}
.core .layui-form .layui-inline{
  margin-right: 0!important;
  padding-left: 4px;
}
.last {
  border-right: none !important;
}
.search-title {
  position: relative;
  height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.search-title span {
  position: absolute;
  left: 16px;
  line-height: 40px;
}
.search-title a {
  color: #01aaed;
}
.search-title a:hover {
  color: #5fb878;
}
.search-title ul {
  position: absolute;
  left: 100px;
  height: 30px;
  padding: 10px 0;
}
.search-title ul li {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  float: left;
  margin-left: 10px;
  border: 1px solid;
  cursor: pointer;
  border-radius: 10px;
  padding-left: 6px;
}
.search-title ul li i {
  font-size: 12px;
}
#search-content {
  border-top: 0px;
  padding-right: 0;
}
#searchResult li:hover {
  border: 1px solid #01aaed;
  color: #01aaed;
}
#searchResult li b {
  font-weight: normal;
  padding-right: 2px;
}
#btn_fold {
  font-size: 14px;
  position: absolute;
  cursor: pointer;
  right: 30px;
  line-height: 40px;
}
.search-name {
  float: left;
  display: block;
  width: 90px;
  line-height: 40px;
}
#fundtype {
  border-bottom: 1px solid #e6e6e6;
  height: auto;
  padding-bottom: 5px;
}
#fundtype ul {
  line-height: 50px;
  padding-left: 90px;
}
#fundtype ul li {
  float: left;
  width: 95px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 4px;
  background-color: #eeeeee;
}
#fundtype ul li a {
  cursor: pointer;
}
#fundcompany {
  border-bottom: 1px solid #e6e6e6;
}
.fundcompany-content a {
  padding: 0 20px;
  cursor: pointer;
  border-right: 1px solid #d4d4d4;
}
#fundyeji {
  border-bottom: 1px solid #e6e6e6;
}
.fundyeji-content a {
  padding: 0 30px;
  cursor: pointer;
}
#fundstar {
  border-bottom: 1px solid #e6e6e6;
  height: auto;
  padding: 10px 0;
}
#fundstar ul {
  line-height: 50px;
  padding-left: 90px;
}
#fundstar ul li {
  float: left;
  width: 95px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 4px;
  background-color: #eeeeee;
}
#fundstar ul li a {
  cursor: pointer;
}
.layui-tab-title li {
  min-width: 10px;
  padding: 0 10px;
}
.layui-tab-content {
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}
.layui-input-inline {
  width: 60px;
}
.layui-form-label {
  padding: 9px 0;
  width: 60px;
  text-align: center;
}
.active {
  background-color: #01aaed !important;
  color: #fff !important;
}
.choice {
  background-color: #01aaed !important;
  color: #fff !important;
}
.choicecom {
  color: #5fb878;
  text-decoration: underline;
}
.savedcond {
  cursor: pointer;
  line-height: 24px;
  padding: 0 4px 0 8px;
  margin: 5px 10px;
  display: block;
  background-color: #eeeeee;
  color: #a6aab8;
  border-radius: 12px;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.savedcond:hover {
  background-color: #aaa;
  color: #fff;
}
.savedcond i {
  float: right;
}
.savedcond i:hover {
  color: #ff5722;
}
.clearfloat {
  clear: both;
  height: 0;
  font-size: 1px;
  line-height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AdvancedQuery.vue